import * as Styled from './styled'
import { Props } from './interfaces'

function ProgressBar({ progress, transitionTime }: Props) {
  return (
    <Styled.Container role="progressbar">
      <Styled.CurrentProgress
        data-testid="current-progress"
        $progress={progress}
        $transitionTime={transitionTime}
      />
    </Styled.Container>
  )
}

ProgressBar.defaultProps = {
  progress: 0,
  transitionTime: 1,
}

export default ProgressBar
